<template>
  <div :class="{ 'has-logo': showLogo }" class="sidebar-inner">
    <logo v-if="showLogo" :collapse="isCollapse"/>
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item
          v-for="route in permission_routes"
          :key="route.path"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>

    <div class="sidebar-footer" :class="{ collapse: isCollapse }">
      <div v-if="!isCollapse" class="footer-user">
        <el-dropdown :hide-on-click="false" trigger="click" @command="doAction">
          <span class="user-trigger">
            <span class="user-avatar">{{ userInitial }}</span>
            <span class="user-name">{{ admin.username }}</span>
            <i class="el-icon-arrow-down"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="updatePassword">{{ $t('message.sys.admin.updatePassword') }}</el-dropdown-item>
            <el-dropdown-item command="logout" divided>{{ $t('message.sys.admin.logout') }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="footer-actions">
        <el-dropdown
          v-if="isCollapse"
          :hide-on-click="false"
          trigger="click"
          @command="doAction"
        >
          <span class="user-avatar collapse-avatar">{{ userInitial }}</span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="updatePassword">{{ $t('message.sys.admin.updatePassword') }}</el-dropdown-item>
            <el-dropdown-item command="logout" divided>{{ $t('message.sys.admin.logout') }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <language
          customClass="sidebar-lang"
          fontColor="#94A3B8"
          :compact="isCollapse"
        ></language>
        <div class="collapse-btn" @click="toggleSideBar" :title="isCollapse ? '展开' : '收起'">
          <i :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></i>
        </div>
      </div>
    </div>

    <el-dialog
      :title="$t('message.sys.admin.updatePassword')"
      v-if="visible.updatePassword"
      :visible.sync="visible.updatePassword"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="90%"
      center>
      <el-form ref="updatePasswordForm" :model="updatePassword" :rules="updatePasswordRules" label-width="80px">
        <el-form-item :label="$t('message.sys.admin.originPassword')" prop="oldPassword">
          <el-input v-model="updatePassword.oldPassword" type="password"></el-input>
        </el-form-item>
        <el-form-item :label="$t('message.sys.admin.newPassword')" prop="newPassword">
          <el-input
            ref="password"
            v-model="updatePassword.newPassword"
            name="text"
            :type="newPasswordType"
            @keyup.enter.native="doUpdatePassword"
          />
          <span class="show-pwd" @click="showPwd('newPassword')">
            <svg-icon :icon-class="newPasswordType === 'password' ? 'eye' : 'eye-open'"/>
          </span>
        </el-form-item>
        <el-form-item :label="$t('message.sys.admin.confirmPassword')" prop="repeatPassword">
          <el-input
            ref="repeatPassword"
            v-model="updatePassword.repeatPassword"
            name="text"
            :type="repeatPasswordType"
            @keyup.enter.native="doUpdatePassword"
          />
          <span class="show-pwd" @click="showPwd('repeatPassword')">
            <svg-icon :icon-class="repeatPasswordType === 'password' ? 'eye' : 'eye-open'"/>
          </span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible.updatePassword = false">{{ $t('message.sys.admin.cancel') }}</el-button>
        <el-button type="primary" v-loading="loading.updatePassword" @click="doUpdatePassword">
          {{ $t('message.sys.admin.confirm') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import Logo from "./Logo";
import SidebarItem from "./SidebarItem";
import Language from "@/components/Language";
import variables from "@/styles/variables.scss";
import * as sysApi from "@/api/sys";

export default {
  components: {SidebarItem, Logo, Language},
  computed: {
    ...mapGetters(["permission_routes", "sidebar", "admin"]),
    activeMenu() {
      const route = this.$route;
      const {meta, path} = route;
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    },
    userInitial() {
      var name = (this.admin && this.admin.username) || "";
      return name ? name.charAt(0).toUpperCase() : "U";
    },
  },
  data() {
    var validRepeat = (rule, value, callback) => {
      if (this.updatePassword.newPassword != value) {
        callback(new Error());
      } else {
        callback();
      }
    };
    return {
      newPasswordType: "password",
      repeatPasswordType: "password",
      loading: {updatePassword: false},
      updatePassword: {},
      visible: {
        updatePassword: false,
      },
      updatePasswordRules: {
        oldPassword: [
          {required: true, trigger: "blur", message: "请输入密码"},
        ],
        newPassword: [
          {required: true, trigger: "blur", message: "请输入新密码"},
        ],
        repeatPassword: [
          {
            required: true,
            trigger: ["blur", "change"],
            message: "请输入确认密码",
          },
          {
            trigger: ["blur", "change"],
            message: "两次密码不正确",
            validator: validRepeat,
          },
        ],
      },
    };
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    showPwd(name) {
      var key = name + "Type";
      if (this[key] === "password") {
        this[key] = "";
      } else {
        this[key] = "password";
      }
      this.$nextTick(() => {
        this.$refs[name].focus();
      });
    },
    doAction(command) {
      if (command == "logout") {
        this.doLogout();
      } else if (command == "updatePassword") {
        this.visible.updatePassword = true;
      }
    },
    doUpdatePassword() {
      this.$refs.updatePasswordForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.loading.updatePassword = true;
        sysApi.adminUpdatePassword(this.updatePassword)
          .then(() => {
            this.visible.updatePassword = false;
            this.loading.updatePassword = false;
            window.location.reload();
          })
          .catch(() => {
            this.loading.updatePassword = false;
          });
      });
    },
    doLogout() {
      this.$store.dispatch("sys/logout").then(() => {
        this.$router.push("/login");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.sidebar-inner {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.sidebar-footer {
  flex-shrink: 0;
  padding: 12px 14px 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);

  &.collapse {
    padding: 12px 0 16px;

    .footer-actions {
      flex-direction: column;
      align-items: center;
      justify-content: center;

      > * + * {
        margin-top: 12px;
        margin-left: 0;
      }
    }

    .collapse-btn {
      margin-left: 0;
    }

    ::v-deep .sidebar-lang {
      width: 28px;
      margin: 0 auto;
    }
  }
}

.footer-user {
  margin-bottom: 10px;

  ::v-deep .el-dropdown {
    display: block;
    width: 100%;
  }
}

.footer-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;

  > * + * {
    margin-left: 8px;
  }
}

.user-trigger {
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0;
  cursor: pointer;
  color: #E2E8F0;
  overflow: hidden;
}

.user-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(59, 130, 246, 0.25);
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  flex-shrink: 0;
  cursor: pointer;
}

.collapse-avatar {
  margin: 0 auto;
}

.user-name {
  margin-left: 8px;
  margin-right: 4px;
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
}

.el-icon-arrow-down {
  font-size: 12px;
  color: #64748B;
  flex-shrink: 0;
}

.collapse-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  color: #94A3B8;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.2s, color 0.2s;
  margin-left: auto;

  &:hover {
    background: rgba(255, 255, 255, 0.08);
    color: #fff;
  }

  i {
    font-size: 16px;
  }
}

.show-pwd {
  position: absolute;
  right: 10px;
  top: 2px;
  font-size: 16px;
  color: #676a6c;
  cursor: pointer;
  user-select: none;
}

::v-deep .sidebar-lang {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: auto;
}
</style>



// WEBPACK FOOTER //
// src/admin/layout/components/Sidebar/index.vue